import { Button, Typography } from "@mui/material";
import React, { ReactNode } from "react";
import { formatText } from "../../../helper/formatText";
import { classNamesList } from "../../../../common/utils/class-name";

import "./style.scss";

interface IPromptProps {
    children: ReactNode;
    button?: IPromptButton;
}

interface IPromptButton {
    label: string;
    position: "top" | "bottom";
    onClick: () => void;
    icon: ReactNode;
}

export const Prompt = (props: IPromptProps) => {
    return <div className={"prompt-wrapper prompt-wrapper--bottom"}>
        <div className={"prompt"}>
            {props.button && props.button.position === "top" &&
                <Button variant={"contained"}
                        className={"prompt-button"}
                        color={"secondary"}
                        onClick={props.button.onClick}
                        startIcon={props.button.icon}
                        size={"large"}>
                {props.button.label}
            </Button>}
            {React.Children.map(props.children, (el =>
                React.isValidElement(el)  ?
                    React.cloneElement(el, {
                        ...el.props,
                        className: classNamesList([el.props.className ?? "", "prompt-text"]),
                        children: !React.isValidElement(el.props.children) ?
                            formatText(el.props.children as string) : el.props.children,
                        }) : el && <Typography className={"prompt-text"}>{formatText(el as string)}</Typography>))}
            {props.button && props.button.position === "bottom" &&
                <Button variant={"contained"}
                        className={"prompt-button"}
                        color={"secondary"}
                        onClick={props.button.onClick}
                        startIcon={props.button.icon}
                        size={"large"}>
                {props.button.label}
            </Button>}
        </div>
    </div>;
};
